<template>
  <v-card elevation="0">
    <mrc_ess_skeleton_loader :loading="skLoading">
      <div>
        <!-- <mrc_ess_iconGroup
          style="top: -50px"
          :is_disabled="disabled"
          :showEdit="hasBtn('edit-organizaiton-configuration')"
          :show_del="hasBtn('delete-organization-configuration')"
          @handleReturn="handleReturn"
          @handleEdit="handleEdit"
          @handleDel="handleDel"
        ></mrc_ess_iconGroup> -->
        <!-- :show_del="hasBtn('delete-company-exchange-rate')" -->
        <v-card elevation="0">
          <v-card-text class="pa-8">
            <mrc_ess_table
              :paginationOptions="params"
              :headers="headers"
              :items="desserts"
              hideAddBtn
              :slotKey="['effective_start_date', 'status']"
              hide-default-footer
            >
              <template v-slot:item.effective_start_date="{ item }">
                <div class="is_flex_between">
                  <span>{{ item.effective_start_date | changeDate() }}</span>
                  <!-- <v-divider vertical></v-divider>
                  <div
                    class="is_flex_column"
                    style="margin-right: 30%;color:var(--main-color);cursor: pointer"
                    @click="updateRate(item.uuid)"
                  >
                    <span>{{ $t('label_update_immediately') }}</span>
                    <v-divider color="primary"></v-divider>
                  </div> -->
                </div>
              </template>
              <template v-slot:item.status="{ item }">
                <mrc_ess_viewbtn
                  :is_used="getStatus(item.effective_start_date)"
                ></mrc_ess_viewbtn>
              </template>
              <template v-slot:item.actions="{ item }" v-if="!disabled">
                <v-icon @click.stop="changeItem(item)">mdi-pencil</v-icon>
                <v-icon style="margin-left: 10%" @click.stop="delItem(item)"
                  >mdi-delete</v-icon
                >
              </template>
            </mrc_ess_table>
            <!-- <v-btn v-if="!disabled"
                   text
                   color="primary"
                   class="addRate"
                   @click="
                flag = true
                dialogTitle = $t('label_Exchange_rate_is_set')
              ">
              {{ $t('label_The_new_currency') }}+
            </v-btn> -->
            <mrc_ess_textAddBtn
              :text="$t('label_The_new_currency')"
              v-if="!disabled"
              @click="
                flag = true
                dialogTitle = $t('label_Exchange_rate_is_set')
              "
            >
            </mrc_ess_textAddBtn>
          </v-card-text>
          <rate-dialog
            v-model="flag"
            :title="dialogTitle"
            @cancel="cancalDialog"
            :paramsData="dialogData"
            @getData="saveAddUpdate"
          >
          </rate-dialog>
          <mrc_ess_submitBtn
            @cancel="$emit('cancel', !disabled)"
            hideSuccess
            v-show="!disabled"
          ></mrc_ess_submitBtn>
        </v-card>
      </div>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>

<script>
import rateDialog from "../components/addRate"
import {
  rate_list,
  rate_update_add,
  rate_del,
  rate_detail,
  rate_del_all,
  get_company_del,
} from "@/service/api/company_set"
export default {
  components: { rateDialog },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  provide() {
    return {
      rateDialogSubmitLoading: this.rateLoading,
    }
  },
  data() {
    return {
      dialogTitle: "",
      rateLoading: { rateLoading: false },
      skLoading: true,
      flag: false,
      desserts: [],
      dialogData: {},
      params: {
        cpage: this.$store.state.cpage,
        pagesize: this.$store.state.pageSize,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  created() {},
  async mounted() {
    this.skLoading = true
    await this.getList()
    this.skLoading = false
  },
  methods: {
    getStatus(val) {
      let num = 0
      if (val < new Date().valueOf()) {
        num = 1
      }
      return num
    },
    async getList(obj) {
      if (obj) {
        this.params = obj
      }
      const list = await rate_list({
        org_level_uuid: this.$store.state.uuid,
        cpage: this.params.cpage,
        pagesize: this.params.pagesize,
      })
      if (list.code == 200) {
        this.desserts = list.data
        this.params.totalcount = list.totalcount
        this.params.totalpage = list.totalpage
        // console.log(list)
      }
    },
    // 立即更新
    updateRate(uuid) {
      console.log(uuid)
    },
    // 修改汇率 打开修改弹窗
    changeItem(item) {
      this.dialogData = item
      this.dialogTitle =
        item.original_currency_uuid + " - " + item.foreign_currency_uuid

      this.flag = true
    },
    // 删除这一条
    delItem(item) {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const index = this.desserts.indexOf(item)
          console.log(item, "delete")
          const del = await rate_del({ uuid: item.uuid })
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })
            this.desserts.splice(index, 1)
            await this.getList()
          }
        })
        .catch(() => {})
    },
    // 取消新增或者修改
    cancalDialog() {},
    // 弹窗修改或者新增
    async saveAddUpdate(params) {
      try {
        this.rateLoading.rateLoading = true
        const data = await rate_update_add(params)
        if (data.code == 200) {
          this.$store.commit(
            "newsTips",
            this.$t("message_The_operation_was_successful")
          )
          await this.getList()
          // this.disabled = !this.disabled
        }
        this.rateLoading.rateLoading = false
        this.flag = false
      } catch (err) {
        this.rateLoading.rateLoading = false
        this.flag = false
      }
    },
    handleReturn() {
      this.$router.go(-1)
    },
    handleEdit() {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          })
          if (del.code == 200) {
            this.delData(this.$store.state.listObj.uuid)
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch("set_topcompanylist")
            }
            this.$router.push({
              name: "enterprise",
            })
          }
        })
        .catch(() => {})
      // this.$myConfirm({ content: $t('message_Confirm_the_deletion') })
      //   .then(async () => {
      //     const del = await raterate_del_alldel({
      //       org_level_uuid: this.params.org_level_uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_original_money"),
          align: "start",
          sortable: false,
          value: "original_currency_uuid",
        },
        {
          text: this.$t("label_Converted_into"),
          align: "start",
          sortable: false,
          value: "foreign_currency_uuid",
        },
        {
          text: this.$t("label_The_latest_currency"),
          align: "start",
          sortable: false,
          value: "exchange_rate",
        },
        {
          text: this.$t("label_Inverse"),
          align: "start",
          sortable: false,
          value: "inverse",
        },
        {
          text: this.$t("label_The_effective_date"),
          align: "start",
          sortable: false,
          value: "effective_start_date",
        },
        {
          text: this.$t("label_state"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
    // headers () {
    //   return this.baseHeader
    // },
  },
  watch: {
    flag(val) {
      if (!val) {
        this.dialogData = {}
      }
    },
    // disabled(val) {
    //   if (val) {
    //     this.baseHeader.pop()
    //   } else {
    //     this.baseHeader.push({
    //       text: ' ',
    //       align: 'start',
    //       sortable: false,
    //       value: 'actions',
    //     })
    //   }
    // }
  },
}
</script>

<style scoped>
.addRate {
  text-align: left;
  margin: 0 10px 20px 20px;
  padding: 10px;
  min-width: 100px;
  position: relative;
  top: -5px;
}
</style>
